import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from 'app/store/actions';
import { Dialog, DialogContent, Typography, Toolbar, AppBar, Avatar, Button, Icon } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import graphqlService from 'app/services/graphqlService';
import LinearBuffer from './Progress';
import { QUERY_USER_BY_PHONE } from './query';
import webrtcPhone from 'app/services/webrtcPhone';

function CallOutDialog(props) {
    var dispatch = useDispatch();
    var calling = useSelector(function(state) { return state.calling; });
    var _s = useState('connecting'), callStatus = _s[0], setCallStatus = _s[1];

    useEffect(function() {
        if (calling.phoneNumber && (!calling.user || calling.user.phoneNumber !== calling.phoneNumber)) {
            graphqlService.query(QUERY_USER_BY_PHONE, { phoneNumber: calling.phoneNumber }, dispatch).then(function(response) {
                if (response.data && response.data.length > 0)
                    dispatch(Actions.setUser(response.data[0]));
            });
        }
    }, [calling, calling.user, calling.phoneNumber, dispatch]);

    useEffect(function() {
        if (calling.phoneNumber) {
            setCallStatus('connecting');
            var onConnected = function() { setCallStatus('connected'); };
            var onEnded = function() { setCallStatus(function(prev) { if (prev === "connected") { setTimeout(function() { dispatch(Actions.clearCall()); }, 3000); return "ended"; } return prev; }); };
            var onEnded = function() { setCallStatus(function(prev) { return prev === 'connected' ? 'ended' : prev; }); };
            var onFailed = function() { setCallStatus('failed'); };

            webrtcPhone.on('callConnected', onConnected);
            webrtcPhone.on('callEnded', onEnded);
            webrtcPhone.on('callFailed', onFailed);

            return function() {
                webrtcPhone.off('callConnected', onConnected);
                webrtcPhone.off('callEnded', onEnded);
                webrtcPhone.off('callFailed', onFailed);
            };
        }
    }, [calling.phoneNumber]);

    function handleClose() {
        dispatch(Actions.clearCall());
        setCallStatus('connecting');
    }

    function handleHangup() {
        webrtcPhone.hangup();
        dispatch(Actions.clearCall());
        setCallStatus('connecting');
    }

    var isOpen = calling && calling.phoneNumber && calling.phoneNumber.length > 0;

    var getTitle = function() {
        switch(callStatus) {
            case 'connected': return '\u0110ang g\u1ecdi - ' + calling.phoneNumber;
            case 'ended': return 'Cu\u1ed9c g\u1ecdi k\u1ebft th\u00fac';
            case 'failed': return 'Kh\u00f4ng k\u1ebft n\u1ed1i \u0111\u01b0\u1ee3c';
            default: return '\u0110ang k\u1ebft n\u1ed1i t\u1edbi ' + calling.phoneNumber;
        }
    };

    var getStatusColor = function() {
        switch(callStatus) {
            case 'connected': return green[600];
            case 'ended': case 'failed': return red[400];
            default: return undefined;
        }
    };

    return React.createElement(Dialog, {
        classes: { paper: 'm-24' },
        open: isOpen ? true : false,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: 'xs'
    },
        React.createElement(AppBar, { position: 'static', elevation: 1, style: { backgroundColor: getStatusColor() } },
            React.createElement(Toolbar, { className: 'flex w-full justify-center' },
                React.createElement(Typography, { variant: 'subtitle1', color: 'inherit' }, getTitle())
            ),
            calling.user && React.createElement('div', { className: 'flex flex-col items-center justify-center pb-24' },
                React.createElement(Avatar, { className: 'w-48 h-48', alt: 'KH', src: window.env.FILE_PREVIEW_URL + calling.user.avatar }),
                React.createElement(Typography, { variant: 'h6', color: 'inherit', className: 'pt-8' }, calling.user.fullName)
            )
        ),
        React.createElement(DialogContent, { classes: { root: 'p-24' }, style: { textAlign: 'center' } },
            callStatus === 'connecting' && React.createElement(LinearBuffer, null),
            callStatus === 'connecting' && React.createElement(Typography, { className: 'mt-12' }, '\u0110ang \u0111\u1ed5 chu\u00f4ng cho kh\u00e1ch h\u00e0ng...'),
            callStatus === 'connected' && React.createElement(Typography, { className: 'mt-12', style: { color: green[600], fontWeight: 'bold' } }, '\u0110\u00e3 k\u1ebft n\u1ed1i - \u0110ang n\u00f3i chuy\u1ec7n'),
            (callStatus === 'ended' || callStatus === 'failed') && React.createElement(Typography, { className: 'mt-12', style: { color: red[500] } }, callStatus === 'failed' ? 'Kh\u00f4ng li\u00ean l\u1ea1c \u0111\u01b0\u1ee3c' : 'Cu\u1ed9c g\u1ecdi \u0111\u00e3 k\u1ebft th\u00fac'),
            (callStatus === 'connected' || callStatus === 'connecting') && React.createElement(Button, {
                variant: 'contained',
                style: { backgroundColor: red[500], color: '#fff', marginTop: 20, minWidth: 160, borderRadius: 28 },
                onClick: handleHangup,
                startIcon: React.createElement(Icon, null, 'call_end')
            }, 'K\u1ebft th\u00fac cu\u1ed9c g\u1ecdi'),
            (callStatus === 'ended' || callStatus === 'failed') && React.createElement(Button, {
                variant: 'contained',
                style: { marginTop: 20, minWidth: 120 },
                onClick: handleClose
            }, '\u0110\u00f3ng')
        )
    );
}

export default CallOutDialog;
